"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectoryTitleWrap = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styles_1 = require("@material-ui/styles");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    DirectoryTitle: {
        height: 16,
        fontSize: 12,
        fontWeight: 700,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 6,
        paddingBottom: 6,
        color: theme ? theme.app.DirectoryTitle.color : "",
    },
}); });
function DirectoryTitleWrap(props) {
    var children = props.children;
    var classes = useStyles();
    return (React.createElement("div", null,
        React.createElement("div", { className: classes.DirectoryTitle },
            " ",
            children)));
}
exports.DirectoryTitleWrap = DirectoryTitleWrap;
//# sourceMappingURL=DirectoryTitleWrap.js.map